import * as DashboardConstants from '../DashboardConstants';

export const UsageTableHeaders = [
    {
        key: 'username',
        header: DashboardConstants.Username
    },
    {
        key: 'logged_in_at',
        header: DashboardConstants.LoggedInAt
    },
    {
        key: 'logged_out_at',
        header: DashboardConstants.LoggedOutAt
    },
    {
        key: 'duration',
        header: DashboardConstants.Duration
    },
    {
        key: 'activity',
        header: DashboardConstants.Activity
    }
];

export const GeoTableHeaders = [
    {
        key: 'geos',
        header: DashboardConstants.Geos
    },
    {
        key: 'unique_users',
        header: DashboardConstants.UniqueUsers
    }
];

export const GeoTableData = [
    {
        id: 1,
        'geos': "India",
        'unique_users': 120,
    },
    {
        id: 2,
        'geos': "United States",
        'unique_users': 200,
    },
    {
        id: 3,
        'geos': "Brazil",
        'unique_users': 10,
    },
    {
        id: 4,
        'geos': "Canada",
        'unique_users': 200,
    },
    {
        id: 5,
        'geos': "France",
        'unique_users': 90,
    },
    {
        id: 6,
        'geos': "Russia",
        'unique_users': 300,
    },
    {
        id: 7,
        'geos': "Pakistan",
        'unique_users': 200,
    },
    {
        id: 8,
        'geos': "Saudi Arabia",
        'unique_users': 100,
    },
    {
        id: 9,
        'geos': "Ireland",
        'unique_users': 20,
    },
]

export const UsageTableData = [
    {
        'username': "User1",
        'logged_in_as': "31 Mar | 12:00PM",
        'logged_out_as': "31 Mar | 12:30PM",
        'duration': "30 mins",
        'activity': "Active a day ago"
    },
    {
        'username': "User2",
        'logged_in_as': "31 Mar | 12:00PM",
        'logged_out_as': "31 Mar | 12:30PM",
        'duration': "30 mins",
        'activity': "Active a day ago"
    },
    {
        'username': "User3",
        'logged_in_as': "31 Mar | 12:00PM",
        'logged_out_as': "31 Mar | 12:30PM",
        'duration': "30 mins",
        'activity': "Active a day ago"
    }
];


